import ConfiguracionRepository from '@/services/ConfiguracionRepository'
import InventarioRepository from '@/services/InventarioRepository'
import cloneDeep from 'lodash.clonedeep'

export default {
  namespaced: true,
  state: {
    listaLotesAnimal: [],
    listaInventarios: [],
    inventariosActual: [],
    inventarioResultado: []
  },
  getters: {
    getLotesCurrentEstablecimiento: (state) => (idEstablecimiento) => {
      return state.listaLotesAnimal.filter(lote => lote.idEstablecimiento === idEstablecimiento)
    },
    getInventarioByLoteId: (state) => (idLoteAnimal, tipoInventario) => {
      if (tipoInventario !== 2) {
        let inicial = cloneDeep(state.listaInventarios.find(inventario => inventario.tipo === tipoInventario)) || null
        if (inicial) {
          inicial.detalleInventario = inicial.detalleInventario.filter(detalle => detalle.idLoteAnimal === idLoteAnimal)
        }
        return inicial
      } else {
        return state.listaInventarios.find(inventario => inventario.tipo === tipoInventario && inventario.detalleInventario[0].idLoteAnimal === idLoteAnimal)
      }
    },
    getInventariosIntermediosByLote: (state) => (idLoteAnimal) => {
      return state.listaInventarios.filter(inventario => inventario.tipo === 2 && inventario.detalleInventario[0].idLoteAnimal === idLoteAnimal)
    },
    getInventariosActualesByLote: (state) => (idLoteAnimal) => {
      return state.inventariosActual.filter(inventario => inventario.loteAnimal.idLoteAnimal === idLoteAnimal)
    },
    getInventariosInicial: (state) => {

      if (!Array.isArray(state.listaInventarios)) {
        return []

      }

      return state.listaInventarios.filter(inventario => inventario.tipo === 1)

    },
    getInventarioByTipo: (state) => (tipoInventario) => {
      return state.listaInventarios.find(inventario => inventario.tipo === tipoInventario) || null
    },
    loteHasInventarioInicial: (state) => (idLoteAnimal) => {
      return state.listaInventarios.some(inventario => inventario.tipo === 1 && inventario.detalleInventario.some(inv => inv.idLoteAnimal === idLoteAnimal))
    }
  },
  mutations: {
    setListaLotesAnimal(state, listaLotes) {
      listaLotes.map(lote => {
        lote.reproductivo = lote.reproductivo === 1 ? true : false
        return lote
      })
      state.listaLotesAnimal = listaLotes
    },

    clearListaLotesAnimal(state) {
      state.listaLotesAnimal = []
    },

    setListaInventarios(state, inventarios) {
      state.listaInventarios = inventarios || []
    },

    clearListaInventarios(state) {
      state.listaInventarios = []
    },

    setInventarioActual(state, inventarios) {
      state.inventariosActual = inventarios
    },

    clearInventariosActual(state) {
      state.inventariosActual = []
    },

    setInventarioResultado(state, inventarios) {
      state.inventarioResultado = inventarios
    },

    clearInventarioResultado(state) {
      state.inventarioResultado = []
    },
  },
  actions: {
    async fetchLotesAnimal({ commit, state, rootState }) {
      if (state.listaLotesAnimal && state.listaLotesAnimal.length !== 0) {
        return
      }
      let idEstablecimiento = rootState.establecimientos.establecimiento.idEstablecimiento
      if(idEstablecimiento !== null){
        let resp = await ConfiguracionRepository.listaLotesAnimal(idEstablecimiento)
        commit('setListaLotesAnimal', resp)
      }
    },

    clearListaLotes({ commit }) {
      commit('clearListaLotesAnimal')
    },

    async fetchListaInventarios({ commit, state, rootState }) {
      if (state.listaInventarios && state.listaInventarios.length !== 0) {
        return
      }
      let idFichaGanadera = rootState.fichas.fichaGanadera.idFichaGanadera
      if (idFichaGanadera && idFichaGanadera != null) {
        let resp = await InventarioRepository.listaInventarioAnimal(idFichaGanadera)
        commit('setListaInventarios', resp)
      }
    },

    clearListaInventarios({ commit }) {
      commit('clearListaInventarios')
    },

    async fetchInventarioActualizado({ commit, state, rootState }, fecha = null) {
      if (state.inventariosActual && state.inventariosActual.length !== 0) {
        return
      }

      let idFichaGanadera = rootState.fichas.fichaGanadera.idFichaGanadera
      if (idFichaGanadera && idFichaGanadera != null) {
        let resp = await InventarioRepository.inventarioActualizado(idFichaGanadera, fecha)
        commit('setInventarioActual', resp)
      }
    },

    clearInventariosActual({ commit }) {
      commit('clearInventariosActual')
    },


    async fetchInventarioResultado({ commit, state, rootState }) {
      if (state.inventarioResultado && state.inventarioResultado.length !== 0) {
        return
      }
      let idFichaGanadera = rootState.fichas.fichaGanadera.idFichaGanadera
      if (idFichaGanadera && idFichaGanadera != null) {
        let resp = await InventarioRepository.inventarioResultado(idFichaGanadera)
        commit('setInventarioResultado', resp)
      }
    },

    clearInventarioResultado({ commit }) {
      commit('clearInventarioResultado')
    },

  }
}